import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return '';
    
    // Expression régulière pour détecter les URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    
    // Remplacer les URLs par des liens HTML
    const linkedText = value.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
    
    // Retourner le HTML sécurisé
    return this.sanitizer.bypassSecurityTrustHtml(linkedText);
  }
} 